(() => {
  'use strict';
  const selector = '[data-pb29-price-filter][open]';
  document.addEventListener('click', event => {
    document.querySelectorAll(selector).forEach(panel => {
      if (!panel.contains(event.target)) panel.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest?.(selector);
    if (!panel) return;
    panel.open = false;
    panel.querySelector('summary')?.focus();
    event.preventDefault();
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll(selector).forEach(panel => {
      if (!panel.contains(event.target)) panel.open = false;
    });
  });
})();
